export class CampaignModel {
  constructor() {
    this.products = [];
    this.flair = {};
    this.url = '';
  }
};

export class UTMModel {
  constructor() {
    this.utm_source = '';
    this.utm_campaign = '';
    this.utm_term = '';
    this.utm_medium = '';
    this.utm_content = '';
    this.referral_source = document.referrer;
  }

  toParams() {
    let params = {};

    if (this.utm_source) params.utm_source = this.utm_source;
    if (this.utm_campaign) params.utm_campaign = this.utm_campaign;
    if (this.utm_term) params.utm_term = this.utm_term;
    if (this.utm_medium) params.utm_medium = this.utm_medium;
    if (this.utm_content) params.utm_content = this.utm_content;
    if (this.referral_source) params.referral_source = this.referral_source;

    return Object.keys(params).length ? params : null;
  }
};